import { deleoLabelRefusalOf, isPendingParcel, type OutboundParcel } from '@/utils/fulfillmentDeleoLabel';

interface PendingParcelNoticeProps {
  parcel: OutboundParcel | null;
}

export const PendingParcelNotice = ({ parcel }: PendingParcelNoticeProps) => {
  if (!parcel || !isPendingParcel(parcel)) {
    return null;
  }
  const refusal = deleoLabelRefusalOf(parcel);
  return (
    <div className="ftbadge" role="status" aria-label="Current pending carrier booking">
      <strong>
        {parcel.carrier} · {parcel.carrierOrderId || 'Carrier booking pending'}
      </strong>
      <span> · {parcel.bookingState} · No courier waybill assigned</span>
      {refusal && <div className="blocked-note">{refusal}</div>}
    </div>
  );
};
